import { createI18n, type PluralizationRule } from 'vue-i18n'

import { messages } from './locales'

const customRule: PluralizationRule = (choice, choicesLength) => {
  if (choice === 0) {
    return 0
  }

  const teen = choice > 10 && choice < 20
  const endsWithOne = choice % 10 === 1
  if (!teen && endsWithOne) {
    return 1
  }
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2
  }

  return choicesLength < 4 ? 2 : 3
}

export const i18n = createI18n({
  locale: 'en-gb',
  fallbackLocale: 'en-gb',
  legacy: false,
  pluralizationRules: {
    ru: customRule,
    bg: customRule,
  },
  messages,
})

export default () => {
  return { provide: { i18n } }
}
